<template>
  <div class="file-upload-selector">
    <UploadFilesSelector
      @add-files="onFilesAdded"
    />
    <UploadCctvExportSelector
      @add-files="onFilesAdded"
      @add-folders="onFoldersAdded"
    />
    <UploadZipSelector
      @add-files="onFilesAdded"
      @add-folders="onFoldersAdded"
    />
  </div>
</template>

<script lang="ts" setup>
import UploadFilesSelector from '@/VueComponents/FileUploadSelector/UploadFilesSelector';
import UploadCctvExportSelector from '@/VueComponents/FileUploadSelector/UploadCctvExportSelector';
import UploadZipSelector from '@/VueComponents/FileUploadSelector/UploadZipSelector';
import UploadSelectorFileUploadModel from '@/VueComponents/FileUploadSelector/models/uploadSelectorFileUploadModel';
import UploadSelectorFolderUploadModel from '@/VueComponents/FileUploadSelector/models/uploadSelectorFolderUploadModel';

const emit = defineEmits<{
  addFiles: [files: UploadSelectorFileUploadModel[]],
  addFolders: [folders: UploadSelectorFolderUploadModel[]]
}>();

function onFilesAdded(files: UploadSelectorFileUploadModel[]) {
  emit('addFiles', files);
}

function onFoldersAdded(folders: UploadSelectorFolderUploadModel[]) {
  emit('addFolders', folders);
}
</script>
